<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.94723 4.65759C3.18977 4.65759 3.4323 4.7498 3.61736 4.93486L8 9.31813L12.3826 4.93486C12.7528 4.56537 13.3528 4.56537 13.7229 4.93486C14.0924 5.30497 14.0924 5.90499 13.7229 6.2751L8.67012 11.3279C8.30001 11.6974 7.69999 11.6974 7.32988 11.3279L2.27711 6.2751C1.90763 5.90499 1.90763 5.30497 2.27711 4.93486C2.46217 4.7498 2.7047 4.65759 2.94723 4.65759Z"
    />
  </svg>
</template>
